import FallbackComponent from '@components/std-components/FallbackComponent'
import React, { FC, lazy, Suspense } from 'react'
import { CreateCopyTemplateFormProps } from './CreateCopyTemplateForm'

const CreateCopyTemplateFormLazy = lazy(() => import('./CreateCopyTemplateForm'))

const CreateCopyTemplateForm: FC<CreateCopyTemplateFormProps> = props => {
  return (
    <Suspense fallback={<FallbackComponent />}>
      <CreateCopyTemplateFormLazy {...props} />
    </Suspense>
  )
}

export default CreateCopyTemplateForm
